// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLERS = "Ko\u010d\u00edkop\u00e9dia - Vyh\u013ead\u00e1va\u010d a porovn\u00e1va\u010d ko\u010d\u00edkov";
export const STROLLEROPEDIA_BRANDS_LIST = "Zna\u010dky ko\u010d\u00edkov";
export const STROLLERS_COMPARISON = "Porovnaj";
export const STROLLER_SEO_GENERAL_DESC = "Ve\u013ek\u00e1 datab\u00e1za ko\u010d\u00edkov Modr\u00e9ho kon\u00edka";
